/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.16.0
 */

import { Switch } from '@nexign/scc-ui-kit';

import ServiceUserDenied, { TServiceUserDeniedTooltip } from './ServiceUserDenied';

const SwitchServiceUserDenied = ({
    placement,
    ...switchProps
}: React.ComponentProps<typeof Switch> & TServiceUserDeniedTooltip) => {
    return (
        <ServiceUserDenied
            placement={placement}
            renderComponent={(disabled) => <Switch {...switchProps} disabled={disabled || switchProps.disabled} />}
        />
    );
};

export default SwitchServiceUserDenied;
